import { useState } from "react";
import { Copy, Check } from "lucide-react";

function CopyInline({ text }: { text: string }) {
  const [copied, setCopied] = useState(false);
  function handleCopy() {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }).catch(() => {});
  }
  return (
    <button
      className="rounded-sm p-1 text-amber-200/60 hover:text-amber-200 transition-colors"
      onClick={handleCopy}
      aria-label="Copy path"
    >
      {copied ? <Check className="h-3 w-3 text-green-500" /> : <Copy className="h-3 w-3" />}
    </button>
  );
}

export function MacOsFdaCallout() {
  return (
    <div className="mt-3 rounded-md border border-amber-500/30 bg-amber-500/10 px-3 py-3 text-xs text-amber-200 space-y-2">
      <p className="font-medium">After install: Grant Full Disk Access</p>
      <ol className="list-decimal list-inside space-y-1 text-amber-200/80">
        <li>
          Open{" "}
          <strong>System Settings &rarr; Privacy &amp; Security &rarr; Full Disk Access</strong>
        </li>
        <li>Click the <strong>+</strong> button</li>
        <li>
          In the file picker, press{" "}
          <kbd className="rounded border border-amber-500/40 bg-amber-500/20 px-1 py-0.5 font-mono">
            Cmd + Shift + G
          </kbd>
        </li>
        <li>
          Paste the path and press Enter:
          <div className="mt-1 flex items-center gap-2">
            <code className="rounded bg-amber-500/20 px-1.5 py-0.5 font-mono">
              /opt/homebrew/bin/fluent-bit
            </code>
            <CopyInline text="/opt/homebrew/bin/fluent-bit" />
          </div>
          <span className="text-xs text-amber-200/60">
            Intel Mac? Use /usr/local/bin/fluent-bit instead
          </span>
        </li>
        <li>Click <strong>Open</strong>, then toggle it <strong>on</strong></li>
        <li>
          Restart the agent to apply the new permission:
          <div className="mt-1 flex items-center gap-2">
            <code className="rounded bg-amber-500/20 px-1.5 py-0.5 font-mono">
              sudo launchctl unload /Library/LaunchDaemons/cloud.prayingmantis.fluent-bit.plist &amp;&amp; sudo launchctl load /Library/LaunchDaemons/cloud.prayingmantis.fluent-bit.plist
            </code>
            <CopyInline text="sudo launchctl unload /Library/LaunchDaemons/cloud.prayingmantis.fluent-bit.plist && sudo launchctl load /Library/LaunchDaemons/cloud.prayingmantis.fluent-bit.plist" />
          </div>
        </li>
      </ol>
      <p className="text-xs text-amber-200/60">
        Without FDA the agent cannot read system logs. This is a macOS security
        restriction that requires manual approval.
      </p>
    </div>
  );
}
